import { useEffect, useState } from 'react';
import { requireSupabase } from '../../lib/supabase';
import type { Profile } from '../../types/hub';

interface MemberRow extends Profile { user_roles?: Array<{ role: string }> }

export function AdminMembersPage() {
  const [members, setMembers] = useState<MemberRow[]>([]);
  const [query, setQuery] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    requireSupabase().from('profiles').select('*, user_roles(role)').order('created_at', { ascending: false })
      .then(({ data, error: loadError }) => {
        setLoading(false);
        if (loadError) setError(loadError.message);
        else setMembers((data ?? []) as MemberRow[]);
      });
  }, []);

  const filtered = members.filter((member) => `${member.full_name || ''} ${member.email || ''}`.toLowerCase().includes(query.toLowerCase()));

  return (
    <div className="hub-page">
      <header className="page-header"><p className="eyebrow">Admin · Members</p><h1>Member accounts</h1><p>Profiles are readable here only because Admin and Super Admin roles pass the database policy.</p></header>
      <section className="card admin-toolbar"><input className="search-field" placeholder="Search name or email…" value={query} onChange={(e) => setQuery(e.target.value)} /><span>{filtered.length} members</span></section>
      {error && <div className="error-banner">{error}</div>}
      {loading ? <div className="page-loading"><span className="loader" />Loading members…</div> : (
        <div className="table-card"><table><thead><tr><th>Member</th><th>Email</th><th>Roles</th><th>Onboarding</th></tr></thead><tbody>{filtered.map((member) => <tr key={member.id}><td>{member.full_name || 'Unnamed member'}</td><td>{member.email || '—'}</td><td>{member.user_roles?.map((item) => item.role).join(', ') || 'member'}</td><td>{member.onboarding_completed_at ? 'Complete' : 'Not complete'}</td></tr>)}</tbody></table></div>
      )}
    </div>
  );
}
